<script setup>
import { ref, watch, onMounted } from 'vue';

const emit = defineEmits('input')
const props = defineProps(['value', 'state']);
const edit = ref(props.value);
const name = ref(null);

const focus = () => {
  if (name.value) {
    name.value.focus();
  }
};

watch(() => props.value, (newValue) => {
  edit.value = newValue;
});

watch(() => edit.value, (newValue) => {
  emit('input', newValue);
});

onMounted(() => {
  focus();
});

defineExpose({focus})
</script>

<template>
  <div>
    <modal-row label="Warehouse" :feedback="state.fkwarehouse">
      <b-select :options="$store.state.settings.defaults.warehouses" :state="state.fkwarehouse | state" v-model="edit.fkwarehouse" />
    </modal-row>
    <modal-row label="Name" :feedback="state.name">
      <b-form-input v-model="edit.name" :state="state.name | state" ref="name" autofocus @keyup.enter="$emit('enter')"/>
    </modal-row>
    <modal-row label="Cost" :feedback="state.cost">
      <b-form-input v-model="edit.cost" :state="state.cost | state" @keyup.enter="$emit('enter')"/>
    </modal-row>
    <modal-row label="Zone" :feedback="state.zone">
      <b-form-input v-model="edit.zone" :state="state.zone | state" @keyup.enter="$emit('enter')"/>
    </modal-row>
    <modal-row label="Receive To" :feedback="state.receiveto">
      <b-checkbox switch v-model="edit.receiveto" :state="state.receiveto | state" />
    </modal-row>
  </div>
</template>

<style scoped>

</style>